<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-12 12:33:30
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-28 10:58:21
 * @FilePath: \bee-transport-h5-v1.0.3d:\project\beecargo-web\src\views\dowloadAPP\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="dowload-app">
    <div class="header-bottom">
      <div class="container-xl">
        <div class="top-style">
          <div class="line-style">
            <span class="dot"></span>
            <span class="lines"></span>
          </div>
          <div class="font-size">
            <div class="text">我们的优势</div>
            <div class="letter">Our Strengths</div>
          </div>
          <div class="line-style">
            <span class="lines"></span>
            <span class="dot"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
          <div class="col-lg-8 col-sm-8 col-xs-12">
            <div class="grid-1">
              <div class="grid-bg">
                <img src="@/assets/homepages/advant1.png" style="width: 100%;height: 100%;" alt="">
              </div>
              <div class="grid1-overlay"></div>
              <div class="grid-content">
                <div class="content-title">车型全面</div>
                <div class="content-text">-覆盖面包车，4米2、5米2、6米8、7米6、9米6、12米、13.7米、16.5米、17.5米，大小车型任选。</div>
                <div class="content-text">-气垫飞翼车、高栏车、防震动冷藏车及港口集装箱拖车，品类多元。</div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-4 col-xs-12">
            <div class="grid-2">
              <div class="grid-bg">
                <img src="@/assets/homepages/advant2.png" style="width: 100%;height: 100%;" alt="">
              </div>
              <div class="grid2-overlay"></div>
              <div class="grid-content">
                <div class="content-title">安全强大的服务平台</div>
                <div class="content-text">-接入TMS调度端</div>
                <div class="content-text">-引入AI人工技术</div>
              </div>
            </div>
          </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-sm-4 col-xs-12">
          <div class="grid-3">
            <div class="grid-bg">
              <img src="@/assets/homepages/advant3.png" style="width: 100%;height: 100%;" alt="">
            </div>
            <div class="grid3-overlay"></div>
            <div class="grid-content">
              <div class="content-title">优化财务管理</div>
              <div class="content-text">-自动生成订单费用</div>
              <div class="content-text">-简化付款流程</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-4 col-xs-12">
          <div class="grid-4">
            <div class="grid-bg">
              <img src="@/assets/homepages/advant4.png" style="width: 100%;height: 100%;" alt="">
            </div>
            <div class="grid4-overlay"></div>
            <div class="grid-content">
              <div class="content-title">业务管控透明化</div>
              <div class="content-text">-物流数据实时监测管控</div>
              <div class="content-text">-定价公开透明</div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-4 col-xs-12">
          <div class="grid-5">
            <div class="grid-bg">
              <img src="@/assets/homepages/advant5.png" style="width: 100%;height: 100%;" alt="">
            </div>
            <div class="grid5-overlay"></div>
            <div class="grid-content">
              <div class="content-title">货物保障</div>
              <div class="content-text">-平台基础自带5万元货保服务</div>
              <div class="content-text">-提供更高额度保险选购</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: ['contentText'],
  methods: {

  }
}
</script>

<style lang='scss' scoped>
.dowload-app {
  background: #f5f5f5;
  padding-bottom: 60px;
  .header-bottom {
    width: 100%;
    padding: 20px 0;
    background: linear-gradient(180deg, #f1b11d 0%, #ec892e 100%);
    opacity: 0.8;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 40px;
    .top-style {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .small-text{
      margin: 5px 0;
      .text{
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        font-size: 20px;
        letter-spacing: 3px;
      }
    }

    .line-style {
      height: 10px;
      display: flex;
      align-items: center;
      flex: 1;
      span {
        display: inline-block;
        background: #ffffff;
        opacity: 1;
      }
      .dot {
        width: 9px;
        height: 9px;
        border-radius: 50%;
      }
      .lines {
        // width: 447px;
        flex: 1;
        height: 1px;
      }
    }
    .font-size {
      margin: 0 20px;
      .text,
      .letter {
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      .text {
        font-size: 40px;
      }
      .letter {
        font-size: 20px;
      }
    }
  }
  .row {
    width: 100%;
    padding: 0;
    margin-left: 0;
  }
  .row>* {
    padding: 0;
  }
    .grid-bg {
      width: 100%;
      height: 100%;
      float: left;
    }
    .grid1-overlay {
      background: linear-gradient( 90deg, #8DD1EB 0%, #777EA8 100%);
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.8;
    }
    .grid2-overlay {
      background: linear-gradient( 90deg, #4692B9 0%, #2E82D6 100%);
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.8;
    }
    .grid3-overlay {
      background: linear-gradient( 90deg, #755D99 0%, #403CAF 100%);
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.8;
    }
    .grid4-overlay {
      background: linear-gradient( 90deg, #C88D57 0%, #BC704E 100%);
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.8;
    }
    .grid5-overlay {
      background: linear-gradient( 90deg, #E7B437 0%, #D19E4A 100%);
      position: relative;
      z-index: 2;
      width: 100%;
      height: 100%;
      opacity: 0.8;
    }
    .grid-content {
      position: absolute;
      z-index: 3;
      left: 0;
      top: 0;
      padding: 30px 120px 30px 30px;
      text-align: left;
      color: #ffffff;
      .content-title {
        font-size: 20px;
        margin-bottom: 20px;
        font-family: PingFangSC;
      }
      .content-text {
        font-size: 15px;
        line-height: 28px;
        font-family: PingFangSC;
      }
    }
    .grid-1 {
      position: relative;
      height: 1.4rem;
      box-shadow: 0px 5px 15px rgba(0,0,0,0.16);
      margin-right: 17px;
      margin-bottom: 17px;
    }
    .grid-2 {
      position: relative;
      height: 1.4rem;
      box-shadow: 0px 5px 15px rgba(0,0,0,0.16);
    }
    .grid-3 {
      position: relative;
      height: 1.4rem;
      box-shadow: 0px 5px 15px rgba(0,0,0,0.16);
    }
    .grid-4 {
      position: relative;
      height: 1.4rem;
      box-shadow: 0px 5px 15px rgba(0,0,0,0.16);
      margin-left: 17px;
      margin-right: 17px;
    }
    .grid-5 {
      position: relative;
      height: 1.4rem;
      box-shadow: 0px 5px 15px rgba(0,0,0,0.16);
    }
}
</style>